export const init = () => {
	if (document.querySelector('a[href^="#"]')) {
		// Vyberte všechny <a> tagy s href, které začíná hashtagem
        const hashStartingLinks = document.querySelectorAll('a[href^="#"]');

        // Projděte všechny nalezené odkazy
        hashStartingLinks.forEach((aTag) => {
        
            aTag.addEventListener('click', function(e){
                e.preventDefault(); 
                const headerElHeight = document.querySelector(".header__navigation")?.offsetHeight || 0;
                const submenuElHeight = document.querySelector(".submenu")?.offsetHeight || 0; 

                const targetEl = document?.getElementById(aTag.getAttribute('href').slice(1)); 
                const y = targetEl?.getBoundingClientRect().top + window.scrollY - headerElHeight - submenuElHeight; 
      
                if(y) {
                    window.scroll({
                    top: y,
                    behavior: 'smooth' 
                    });
                }
            });
        });
	}
};
